// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__2Gx9R","questions":"styles_questions__2A7vU","footer":"styles_footer__27KXY"};